
import { Component, Vue, Prop } from 'vue-property-decorator';
import InfoTooltip from './InfoTooltip.vue';
import { DevicesModule } from '~/store/modules/devices';
import { DisplayedInfo } from '~/interfaces/device.interface';
import NetatmoIcon from '~/components/NetatmoIcon.vue';
import { humanReadableDeviceTitle } from '~/filters/humanReadableDeviceTitle';
import { Device as IDevice } from '~/interfaces/device.interface';
import ExpandingItems from '~/components/Device/ExpandingItems/index.vue';
import StolenDevice from './StolenDevice.vue';

@Component({
    components: {
        StolenDevice,
        InfoTooltip,
        NetatmoIcon,
        ExpandingItems,
    },
    filters: {
        humanReadableDeviceTitle,
    },
})
export default class Device extends Vue {
    @Prop() elementType!: string;
    @Prop() device!: IDevice;

    get infoToDisplay(): DisplayedInfo[] {
        const info: DisplayedInfo[] = [];
        // convert device id to base 10 after removing the ':' separators from the id
        const currentMacAsBase10 = parseInt('0x' + this.device.id.replace(/:/g, ''), 16);
        DevicesModule.deviceInformationArray
            // only keep lines that have info for our device type
            .filter((deviceInformation) => deviceInformation.product === this.device.type)
            .forEach((deviceInformation) => {
                const isInRange = (typeof deviceInformation.start === 'number' && typeof deviceInformation.end === 'number')
                    && currentMacAsBase10 >= deviceInformation.start && currentMacAsBase10 <= deviceInformation.end;
                const isInList = deviceInformation.list?.find((mac) => mac === currentMacAsBase10);
                // check if the device fulfills any condition
                if (isInRange || isInList) {
                    // push the corresponding info
                    info.push({
                        description: deviceInformation.description,
                        criticality: deviceInformation.criticality,
                    });
                }

            });
        return info;
    }
}
